import { FaqExportScope, IFaqExportDTO } from '@/models/faqImportExport.model';

class ExportFaqsDTO implements IFaqExportDTO {
  scope: FaqExportScope;

  channelId?: number;

  question?: string;

  answer?: string;

  constructor({
    scope,
    channelId,
    question,
    answer,
  }: {
    scope: FaqExportScope;
    channelId?: number;
    question?: string;
    answer?: string;
  }) {
    this.scope = scope;
    if (channelId) {
      this.channelId = channelId;
    }
    if (question) {
      this.question = question;
    }
    if (answer) {
      this.answer = answer;
    }
  }
}

export default ExportFaqsDTO;
